import * as React from 'react';
import { Controller, Toolbar, MainMenu, Menu } from '@tencent/workbench';
import { ReplacePictureFeature } from './replace-picture-feature';
import {
    TOOLBAR_ITEMS,
    config,
    MENU_CONFIGS,
    REPLACE_PICTURE_FROM_FILE_CONFIG,
    REPLACE_PICTURE_FROM_CLIPBOARD_CONFIG,
} from './config';
import { wrapIdForPic } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class ReplacePictureController {
    constructor(private readonly feature: ReplacePictureFeature) {}

    @Toolbar(wrapIdForPic(config.id), 'dropdownContent')
    public getPcBtnDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu" itemStyle={{ width: 110, minWidth: 110 }}/>;
    }

    @Toolbar(wrapIdForPic(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Menu(REPLACE_PICTURE_FROM_FILE_CONFIG.name, 'onClick')
    public replacePicFromFile() {
        this.feature.replacePic(true);
    }

    @Menu(REPLACE_PICTURE_FROM_CLIPBOARD_CONFIG.name, 'onClick')
    public replacePicFromClipboard() {
        this.feature.replacePic(false);
    }
}
